import * as yup from 'yup'

export const editTemplateTitleFormValidator = yup.object({
  // Matches `@IsNotEmpty()` on RenameCollectDataTemplateDto.
  name: yup.string().trim().required('Template name is required'),
})
